import React, { useContext } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { createStructuredSelector } from 'reselect';
import { v4 as uuidV4 } from 'uuid';
import arrayMutators from 'final-form-arrays';

// Global Services
import { AppState } from 'services/types';
import { updateQueryString } from 'services/router/actions';
import { setItem } from 'services/virtualizedTable/actions';
import { VirtualizedTableItem } from 'services/virtualizedTable/types';
import { selectVirtualizedTableColumnInitialValues } from 'services/virtualizedTable/selectors';

import unset from 'forms/mutators/unset';

import { VirtualizedTableContextProviderValue } from '../../types';
import VirtualizedTableItemForm from '../VirtualizedTableItemForm';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { CREATE_MODAL_QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    initialValues: ReturnType<typeof selectVirtualizedTableColumnInitialValues>;
}

type Props = ConnectedProps;

export const VirtualizedTableCreateFormWrapperComponent = (
    props: Props
): React.ReactElement => {
    const dispatch = useDispatch();
    const { onCreate, validateRow, setItemFormat } =
        useContext<VirtualizedTableContextProviderValue>(
            VirtualizedTableContext
        );
    const { initialValues } = props;

    const onSubmit = (item: VirtualizedTableItem): void => {
        const uuid = uuidV4();
        const payload = {
            ...item,
            uuid
        };
        let newItem = {
            ...payload,
            key: uuid
        };
        if (setItemFormat) newItem = setItemFormat(newItem);
        dispatch(setItem([newItem]));
        dispatch(
            updateQueryString({
                [CREATE_MODAL_QUERY_STRING_PARAM]: undefined
            })
        );
        if (onCreate) onCreate(payload);
    };

    return (
        <FinalForm
            onSubmit={onSubmit}
            mutators={{
                unset,
                ...arrayMutators
            }}
            render={VirtualizedTableItemForm}
            subscription={{}}
            initialValues={initialValues}
            keepDirtyOnReinitialize
            validate={validateRow}
        />
    );
};

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    initialValues: selectVirtualizedTableColumnInitialValues
});

export default connect(mapStateToProps)(
    VirtualizedTableCreateFormWrapperComponent
);
